import { Api } from 'common/api';
import { StriveContent } from 'services/content/types';

export const getPrivacyPolicy = (): Promise<StriveContent> => {
  return Api.get<StriveResponse<any>>(
    `${API_HOST}/api/strive-proxy/restapi/v1/content/page/privacy-policy`,
  ).then((res) => {
    if (!res.ok) {
      throw new Error('Error get privacy-policy');
    }
    return {
      page: res.data.Data.name,
      title: res.data.Data.structure['full area'][0].standart.page_title.value,
      content:
        res.data.Data.structure['full area'][1].section.section_content.value,
    };
  });
};
